<template>
  <div class="qr-code-upload" :class="{ 'is-block': block }">
    <div v-if="imageUrl" class="qr-preview-box">
      <img :src="imageUrl" class="qr-preview-img" alt="收款二维码" @click="handlePreview" />
      <div v-if="!disabled" class="qr-preview-mask">
        <i class="el-icon-zoom-in" title="预览" @click="handlePreview"></i>
        <i class="el-icon-delete" title="删除" @click="handleRemove"></i>
      </div>
    </div>
    <el-upload
      v-else
      class="qr-uploader"
      action=""
      :show-file-list="false"
      :disabled="disabled"
      :http-request="handleUpload"
      :before-upload="beforeUpload"
      accept="image/jpeg,image/jpg,image/png,image/gif">
      <div class="qr-uploader-trigger">
        <i class="el-icon-plus"></i>
        <span v-if="block" class="qr-uploader-tip">{{ uploadText }}</span>
      </div>
    </el-upload>
    <el-dialog :visible.sync="previewVisible" append-to-body title="二维码预览" width="420px">
      <img :src="imageUrl" alt="二维码" class="qr-preview-dialog" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'QrCodeUpload',
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    uploadText: {
      type: String,
      default: '上传手机截图',
    },
  },
  data() {
    return {
      previewVisible: false,
    };
  },
  computed: {
    imageUrl() {
      return this.value;
    },
  },
  methods: {
    beforeUpload(file) {
      const isImage = /^image\/(jpeg|jpg|png|gif)$/i.test(file.type);
      if (!isImage) {
        this.$message.error('请上传 jpg/png/gif 格式图片');
        return false;
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message.error('图片不能超过 10M');
        return false;
      }
      return true;
    },
    handleUpload({ file }) {
      const form = new FormData();
      form.append('file', file);
      const loading = this.$loading({ lock: true, text: '上传解析中...' });
      this.$http
        .post('/upload/uploadImage', form)
        .then((res) => {
          loading.close();
          if (res.data.code === 0) {
            const data = res.data.data || {};
            const imageUrl = data.qr_image || data.image_url || '';
            const qrCode = data.qr_code || '';
            this.$emit('input', imageUrl);
            this.$emit('change', { qr_image: imageUrl, qr_code: qrCode });
            this.$message.success(res.data.msg || '上传成功');
          } else {
            this.$message.error(res.data.msg || '上传失败');
          }
        })
        .catch((e) => {
          loading.close();
          this.$message.error(e.message || '上传失败');
        });
    },
    handleRemove() {
      this.$emit('input', '');
      this.$emit('change', { qr_image: '', qr_code: '' });
    },
    handlePreview() {
      if (!this.imageUrl) {
        return;
      }
      this.previewVisible = true;
    },
  },
};
</script>

<style scoped>
.qr-uploader-trigger {
  width: 120px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #8c939d;
  font-size: 28px;
  transition: border-color 0.2s;
}

.qr-uploader-trigger:hover {
  border-color: #409eff;
  color: #409eff;
}

.qr-preview-box {
  position: relative;
  width: 120px;
  height: 120px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f7fa;
}

.qr-preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
  display: block;
}

.qr-preview-mask {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  font-size: 20px;
  opacity: 0;
  transition: opacity 0.2s;
}

.qr-preview-box:hover .qr-preview-mask {
  opacity: 1;
}

.qr-preview-mask i {
  cursor: pointer;
}

.qr-preview-dialog {
  display: block;
  max-width: 100%;
  margin: 0 auto;
}

/* 右侧通栏：高度随左侧表单拉伸 */
.qr-code-upload.is-block {
  width: 100%;
  height: 100%;
}

.qr-code-upload.is-block .qr-uploader,
.qr-code-upload.is-block .qr-uploader ::v-deep .el-upload {
  width: 100%;
  height: 100%;
  display: block;
}

.qr-code-upload.is-block .qr-uploader-trigger {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.qr-code-upload.is-block .qr-uploader-tip {
  margin-top: 12px;
  font-size: 13px;
  line-height: 1.4;
  color: #909399;
}

.qr-code-upload.is-block .qr-preview-box {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.qr-code-upload.is-block .qr-preview-img {
  object-fit: contain;
}
</style>
